import axios from "axios";
import { server } from "../../server";

// Get all auctions (public)
export const getAllAuctions = (status, page = 1) => async (dispatch) => {
  try {
    dispatch({ type: "getAllAuctionsRequest" });
    let url = `${server}/auction/get-auctions?page=${page}`;
    if (status) url += `&status=${status}`;
    const { data } = await axios.get(url);
    dispatch({ type: "getAllAuctionsSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "getAllAuctionsFailed", payload: error.response?.data?.message });
  }
};

// Get single auction
export const getAuction = (id) => async (dispatch) => {
  try {
    dispatch({ type: "getAuctionRequest" });
    const { data } = await axios.get(`${server}/auction/get-auction/${id}`);
    dispatch({ type: "getAuctionSuccess", payload: data.auction });
  } catch (error) {
    dispatch({ type: "getAuctionFailed", payload: error.response?.data?.message });
  }
};

// Place bid
export const placeBid = (auctionId, amount) => async (dispatch) => {
  try {
    dispatch({ type: "placeBidRequest" });
    const { data } = await axios.post(
      `${server}/auction/place-bid/${auctionId}`,
      { amount },
      { withCredentials: true }
    );
    dispatch({ type: "placeBidSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "placeBidFailed", payload: error.response?.data?.message });
  }
};

// Admin: Get all auctions
export const getAdminAuctions = (status, page = 1) => async (dispatch) => {
  try {
    dispatch({ type: "getAdminAuctionsRequest" });
    let url = `${server}/auction/admin-all-auctions?page=${page}`;
    if (status) url += `&status=${status}`;
    const { data } = await axios.get(url, { withCredentials: true });
    dispatch({ type: "getAdminAuctionsSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "getAdminAuctionsFailed", payload: error.response?.data?.message });
  }
};

// Admin: Create auction
export const createAuction = (auctionData) => async (dispatch) => {
  try {
    dispatch({ type: "createAuctionRequest" });
    const { data } = await axios.post(`${server}/auction/create-auction`, auctionData, {
      withCredentials: true,
    });
    dispatch({ type: "createAuctionSuccess", payload: data.auction });
  } catch (error) {
    dispatch({ type: "createAuctionFailed", payload: error.response?.data?.message });
  }
};

// Admin: End auction
export const endAuction = (id) => async (dispatch) => {
  try {
    dispatch({ type: "endAuctionRequest" });
    const { data } = await axios.put(`${server}/auction/end-auction/${id}`, {}, {
      withCredentials: true,
    });
    dispatch({ type: "endAuctionSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "endAuctionFailed", payload: error.response?.data?.message });
  }
};
